import { Box, Container, Typography } from "@mui/material";
import React, { useEffect, useState } from "react";
import CustomButton from "../CustomButton";
import { ChevronRightRounded } from "@mui/icons-material";
/* import { news1, news2, news_image } from "../../assets/images"; */
import { collection, db, getDocs } from "../../firebaseConfig";
import dayjs from "dayjs";
import { useNavigate } from "react-router-dom";

const NewsSection = () => {
  const navigate = useNavigate();
  const [articles, setArticles] = useState([]);

  // Fetch data from Firestore when the component loads
  useEffect(() => {
    const fetchData = async () => {
      const querySnapshot = await getDocs(collection(db, "articles"));
      const articleList = querySnapshot.docs.map((doc) => ({
        id: doc.id,
        ...doc.data(),
      }));

      setArticles(articleList);
    };

    fetchData();
  }, []);

  const convertFirebaseTimestamp = (timestamp) => {
    if (!timestamp || !timestamp.seconds) return "Invalid Date";
    return dayjs.unix(timestamp.seconds).format("MMMM D, YYYY");
  };


  return (
    <Box
      sx={{
        width: "100vw",
        background: "linear-gradient(to bottom, #DB5430, rgba(112, 59, 20, 0))",
        mb: 10,
      }}
    >
      <Container
        sx={{
          height: { md: "60vh" },
          display: "flex",
          flexDirection: { xs: "column", md: "row" },
          justifyContent: "space-between",
          alignItems: "center",
          pt: { xs: 5 },
        }}
      >
        <Box
          sx={{
            width: { xs: "100%", md: "35%" },
            mb: { xs: 5 },
          }}
        >
          <Typography variant="h7" sx={{ mb: "1rem" }}>
            News
          </Typography>
          <Typography variant="h2" sx={{ width: "90%", mb: "1rem" }}>
            Latest News
          </Typography>
          <Typography>
            Across Africa, nations are not prepared for the imminent demand that
            will be placed on their education systems, and nations already face
            the challenges of insufficient schools, trained teachers.
          </Typography>
          <Box>
            <CustomButton sx={{ my: "1rem" }} onClick={() => navigate("/news")}>
              <Typography>View all news</Typography>
              <ChevronRightRounded />
            </CustomButton>
          </Box>
        </Box>
        <Box
          sx={{
            width: { xs: "100%", md: "55%" },
            height: { xs: "50vh", md: "80%" },
            /* backgroundColor: "#222222", */
            borderRadius: 10,
            display: "flex",
            flexDirection: "column",
            justifyContent: "center",
            alignItems: "center",
            gap: 2,
          }}
        >
          {articles.map((article) => (
            <Box
              key={article.id}
              sx={{
                bgcolor: "whitesmoke",
                height: { md: 120 },
                width: "100%",
                display: "flex",
                flexDirection: "row",
                alignItems: "center",
                justifyContent: "flex-start",
                gap: 2,
                p: 1,
                borderRadius: 3,
              }}
            >
              <Box sx={{ width: { xs: "20%", md: "15" } }}>
                <Box
                  sx={{
                    display: "flex",
                    bgcolor: "primary.main",
                    flexDirection: "column",
                    alignItems: "center",
                    justifyContent: "center",
                    height: { xs: 50, md: 80 },
                    width: { xs: 50, md: 80 },
                    borderRadius: 5,
                    boxShadow: 5,
                    backgroundImage: `url(${article.image})`,
                    backgroundSize: "cover",
                    backgroundRepeat: "no-repeat",
                    backgroundPosition: "center",
                  }}
                ></Box>
              </Box>
              <Box sx={{ display: "flex", flexDirection: "column" }}>
                <Box
                  sx={{
                    display: "flex",
                    flexDirection: "row",
                    alignItems: "center",
                  }}
                >
                  <Typography
                    sx={{
                      fontSize: "0.8rem",
                      fontWeight: 600,
                      mr: 0.5,
                      color: "primary.main",
                    }}
                  >
                    {article.category}
                  </Typography>
                  <hr
                    style={{
                      width: 2,
                      borderStyle: "none",
                      border: "2px solid #222222",
                      borderRadius: 100,
                    }}
                  />
                  <Typography
                    sx={{ fontSize: "0.8rem", fontWeight: 600, ml: 0.5 }}
                  >
                    {convertFirebaseTimestamp(article.createdAt)}
                  </Typography>
                </Box>
                <Typography>{article.title}</Typography>
              </Box>
            </Box>
          ))}
        </Box>
      </Container>
    </Box>
  );
};

export default NewsSection;
